import loginForm from './login-form'
import resetPasswordForm from './reset-password-form'
import createAccountForm from './create-account-form'

export default {
    loginForm,
    resetPasswordForm,
    createAccountForm,
}